/*!
 * AGL DLS Components built with Stencil
 */
import { h, Host } from '@stencil/core';
import { titleOptions, appearanceOptions, topMarginOptions } from '../../types/component.types';
import { checkSlottedContentForInvalidHTML, validateProp } from './../../utils/utils';
export const Heading = ({ host, type, styledAs, appearance, topMargin }, children) => {
  checkSlottedContentForInvalidHTML(host, [
    'dls-h1',
    'dls-h2',
    'dls-h3',
    'dls-h4',
    'dls-h5',
    'dls-h6',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'dls-text',
    'span',
    'slot',
    'br'
  ]);
  validateProp('styledAs', styledAs, titleOptions, true);
  validateProp('appearance', appearance, appearanceOptions, true);
  validateProp('topMargin', topMargin, topMarginOptions, false);
  const Tag = type;
  return (h(Host, null,
    h(Tag, { class: {
        ['dls-' + styledAs]: true,
        ['dls-' + appearance + '-colour']: true,
        ['dls-top-margin--' + topMargin]: !!topMargin
      } }, children)));
};
